module.exports = __webpack_public_path__ + "static/media/French.80ff86f1.jpeg";